import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { DeclarationModel, CustomerModel } from '../../../domain/models'
import {
  fetchCustomer,
  fetchDeclaration,
  resetDeclaration,
  saveDeclaration,
  updateDeclaration
} from '../../../main/usecases'

import { maskCpf, formatDate } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  EditorCard,
  ServicesHeader,
  SubHeader,
  ResetModal
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  PrinterSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const Declaration = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [declaration, setDeclaration] = useState<DeclarationModel>()
  const [declarationData, setDeclarationData] = useState('')
  const [loading, setLoading] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)
  const alert = useAlert()
  const { modalBox } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <ResetModal
        id={match?.params?.idassessment}
        loading={resetLoading}
        resetDocument={resetDeclaration}
        setDocument={setDeclaration}
        setDocumentData={setDeclarationData}
        document="declaração"
      />,
      'Resetar Declaração',
      '32%'
    )
  }

  const onSaveDeclaration = async () => {
    const body = {
      ...(declaration?.cdDeclaracao && {
        cdDeclaracao: declaration?.cdDeclaracao
      }),
      declaracao: declarationData
    }

    try {
      setResetLoading(true)
      if (declaration?.cdDeclaracao) {
        await updateDeclaration({
          id: match?.params?.idassessment
        }).update(body)
        setRefresh((prev: any) => !prev)
      } else {
        await saveDeclaration({
          id: match?.params?.idassessment
        }).post(body)
        setRefresh((prev: any) => !prev)
      }
      setResetLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handlePrinter = async () => {
    const body = {
      ...(declaration?.cdDeclaracao && {
        cdDeclaracao: declaration?.cdDeclaracao
      }),
      declaracao: declarationData
    }

    try {
      if (declaration?.cdDeclaracao) {
        await updateDeclaration({
          id: match?.params?.idassessment
        }).update(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      } else {
        await saveDeclaration({
          id: match?.params?.idassessment
        }).post(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    window.onafterprint = function () {
      document
        ?.querySelectorAll('[style="display:none !important;"]')[0]
        ?.setAttribute('style', 'display: block !important;')
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        setCustomer(responseCustomer)
        const responseDeclaration = await fetchDeclaration({
          id: match?.params?.idassessment
        }).load()
        setDeclaration(responseDeclaration)
        setDeclarationData(responseDeclaration?.declaracao)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      ...(declaration?.cdDeclaracao && {
        cdDeclaracao: declaration?.cdDeclaracao
      }),
      declaracao: declarationData
    }

    try {
      setLoading(true)
      if (declaration?.cdDeclaracao) {
        await updateDeclaration({
          id: match?.params?.idassessment
        }).update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } else {
        await saveDeclaration({
          id: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Error ao salvar/atualizar a Declaração', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match?.params?.id}/prontuario`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Declaração"
          hasPrinter
          disabled={loading}
          onPrinter={handlePrinter}
        />
        <EditorCard
          docType="declaração"
          data={declaration && declaration?.declaracao}
          setData={setDeclarationData}
          title=""
          height="auto"
          hasReset
          openResetModal={() => {
            onSaveDeclaration()
            handleOpenResetModal()
          }}
        />
        <S.ButtonsContainer className="no-print">
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            disabled={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<PrinterSvg />}
            className="button-printer"
            onClick={handlePrinter}
          >
            Imprimir
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link to={`/meus-pacientes/${match?.params?.id}/prontuario`}>
              Retornar à listagem
            </Link>
          </Button>

          {declaration?.dataUltimaModificacao && (
            <p>
              Data da última atualização:{' '}
              {formatDate(declaration?.dataUltimaModificacao || '')}
            </p>
          )}
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Declaration
